@if (maxItems() > currentNumItems()) {
    <div class="blue35-button" (click)="onSeeMoreClicked()">Vis mer</div>
}